export default __webpack_public_path__ + "static/media/notification-white.d3cc377e.svg";